export const aiAnsweringCustomModuleName = "Shared Topics Module";
export const aiAnsweringCommonAppName = "Shared Topics";
export const aiOrderingCustomModuleName = "Shared Topics Module";
export const aiOrderingCommonAppName = "Shared Topics";
export const aiDentalSchedulingCustomModuleName = "Shared Configuration Module";
export const aiDentalSchedulingCommonAppName = "Shared Configuration";
